<template>
  <div class="records-list">

    <div
        class="d-flex s-p-3 bg-white
          justify-content-between
          align-items-center
        "
        v-if="filterByDate"
      >
        <template v-if="
              filterByDate &&
              filterByDate.show_calendar &&
              !filterByDate.show_option
            ">
          <datepicker
            placeholder="請輸入查詢開始時間"
            @input="
              (e) => {
                startAt = fixDate(e);
              }
            "
            :value="startAt"
            bootstrap-styling
            format="yyyy/MM/dd"
            :language="zh"
            class="p-0 field__input mr-3"
            input-class="px-3 text-center"
            :disabled-dates="disabledDates"
            popover-align="center"

            @selected="dateStartChange"
          >
          </datepicker>
          <div class="mr-3">─</div>
        </template>
        <template
          v-if="
            filterByDate &&
            filterByDate.show_calendar
          ">

          <datepicker
            placeholder="請輸入查詢結束時間"
            @input="
              (e) => {
                endAt = fixDate(e);
              }
            "
            :value="endAt"
            bootstrap-styling
            format="yyyy/MM/dd"
            :language="zh"
            class="p-0 field__input"
            :class="filterByDate.show_option ? 'mr-3' : ''"
            input-class="px-3 text-center"
            position="center"
            :disabled-dates="disabledDates"
            @selected="dateEndChange"
          >
          </datepicker>
        </template>

        <select
          class="form-control"
          v-if="
            filterByDate &&
            filterByDate.show_option
          "
          @change="dateOptionChange"
          :value="daysDiff"
        >
          <option
            v-for="i in filterByDate.options"
            :key="i.key"
            :value="i.key"
          >
            {{ i.title }}
          </option>
        </select>
      </div>

    <template v-if="useCustomLayout">
      <PointLogItem
        v-for="item in pointLogs"
        :key="item.id"
        class="s-mb-3"
        :log="item"
        :field-setting="fieldSetting"
      />
    </template>
    <template v-else>
      <PointCard
        v-for="item in pointLogs"
        :key="item.id"
        :title="item.name"
        :date="item.date"
        :date-label="'交易日期'"
        :type-text="item.type_text"
        :point-need-text="item.point_need_text"
      />
    </template>
    <PointPagination v-model="page" :totalPage="totalPage"></PointPagination>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import PointPagination from "@/pages/Liff/Point/PointPagination";
import PointCard from "@/components/Page/Liff/Point/PointCard";
import PointLogItem from "@/components/Page/Liff/Point/PointLogItem";
import pointApi from "@/apis/liff/v2/point";
import { zh } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    PointPagination,
    PointCard,
    PointLogItem,
    Datepicker,
  },
  props: {
    eventCode: {
      type: String,
      default: null,
    },
    forceSourceType: {
      type: String,
      default: null,
    },
    filterByDate: {
      type: Object,
      default: null,
    },
    fieldSetting: {
      type: Object,
      default: null,
    },
  },
  computed: {
    useCustomLayout() {
      return _.get(this.fieldSetting, "list", []).length > 0;
    },
  },
  data() {
    return {
      zh,
      pointLogs: [],
      page: 1,
      totalPage: 1,
      startAt: null,
      endAt: moment().format("YYYY-MM-DD"),
      disabledDates: { from: new Date() },
      daysDiff: 0,
    };
  },
  watch: {
    page() {
      this.fetchPointLogs();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let filter = this.filterByDate;
      if (filter) {
        if (
          (filter.show_option && !filter.show_calendar) ||
          (!filter.show_option && !filter.show_calendar && filter.options && filter.options.length > 0)
        ) {
          this.setDateRangeByQueryOrFirstOption();
        } else if (filter.show_option && filter.show_calendar) {
          this.endAt = this.$route.query.endAt || moment().format("YYYY-MM-DD");

          // Validate if query params exist in current tab's options
          let queryDaysDiff = filter.options[0].key;
          let isValidOption = false;
          if (this.$route.query.endAt && this.$route.query.startAt) {
            queryDaysDiff = moment(this.$route.query.endAt).diff(
              this.$route.query.startAt,
              "days"
            );
            // Check if this daysDiff exists in current tab's options
            isValidOption = filter.options.some(option => option.key == queryDaysDiff);
          }

          this.daysDiff = isValidOption ? queryDaysDiff : filter.options[0].key;
          this.startAt = isValidOption
            ? this.$route.query.startAt
            : moment().subtract(this.daysDiff, "days").format("YYYY-MM-DD");
        } else if (!filter.show_option && filter.show_calendar && !filter.start_at && filter.options?.length > 0) {
          this.startAt =
             this.$route.query.startAt ||
             moment().subtract(filter.options[0].key, "days").format("YYYY-MM-DD");
        }
        else {
          this.startAt =
             this.$route.query.startAt ||
             moment().subtract(6, "days").format("YYYY-MM-DD");
        }
      }

      this.fetchPointLogs();
    },
    async fetchPointLogs() {
      try {
        let params = {};

        if (this.forceSourceType) {
          params.force_source_type = this.forceSourceType;
        }

        if (this.filterByDate) {
          if (this.startAt == null || this.endAt == null) return;

          if (
            this.startAt != this.$route.query.startAt ||
            this.endAt != this.$route.query.endAt
          ) {
            this.$router.push({
              path: this.$route.path,
              query: {
                ...this.$route.query,
                startAt: this.startAt,
                endAt: this.endAt,
              },
            });
          }
        }

        // this.sourceConfig.filter_by_date.start_at 是開始時間的最小時，所以當設定的開始時間小於此值時，要重設為此值
        if (this.filterByDate?.start_at) {
          this.startAt = moment(this.sourceConfig.filter_by_date.start_at).diff(this.startAt, 'days') > 0 ?
            moment(this.filterByDate.start_at).format("YYYY-MM-DD") :
            this.startAt ?? moment(this.filterByDate.start_at).format("YYYY-MM-DD");
        }

        params.start_at = this.startAt;
        params.end_at = this.endAt;

        let res = await pointApi.listPointsLogs(this.eventCode, this.page, params);
        let point_logs = res.data;

        if (!point_logs || !point_logs.length) {
          this.pointLogs = [];
          return;
        }

        this.totalPage = res.meta.last_page;

        this.pointLogs = point_logs.map((pl) => ({
          ...pl,
          id: pl.id,
          name: pl.description,
          description: pl.description,
          type: pl.type,
          type_text: pl.transaction_type ?? "",
          date: pl.updated_at_date ?? "",
          created_at_formatted: pl.updated_at_date ?? "",
          status: "finish",
          point_need_text: this.formatPointAdjust(pl.point_adjust),
        }));

        if (res.links.next === null) {
          this.noMore = true;
        }
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "錯誤",
          text: "未支援的資料來源",
        });
      }
    },
    setDateRangeByQueryOrFirstOption() {
      let filter = this.filterByDate;
      this.daysDiff = filter.options[0].key;
      this.endAt = moment().format("YYYY-MM-DD");

      // Validate if query params exist in current tab's options
      let isValidOption = false;
      if (this.$route.query.startAt && this.$route.query.endAt) {
        const queryDaysDiff = moment(this.$route.query.endAt).diff(
          this.$route.query.startAt,
          "days"
        );
        // Check if this daysDiff exists in current tab's options
        isValidOption = filter.options.some(option => option.key == queryDaysDiff);

        if (isValidOption) {
          this.daysDiff = queryDaysDiff;
        }
      }

      this.startAt = isValidOption
        ? this.$route.query.startAt
        : moment().subtract(this.daysDiff, "days").format("YYYY-MM-DD");
    },
    dateStartChange(value) {
      let filter = this.filterByDate;

      this.startAt = moment(value).format("YYYY-MM-DD");

      if (filter.show_option) {
        this.endAt = (
          moment().diff(moment(value).add(this.daysDiff, "days")) < 0
            ? moment()
            : moment(value).add(this.daysDiff, "days")
        ).format("YYYY-MM-DD");
      } else {
        if (moment(this.endAt).diff(moment(value)) < 0) {
          this.endAt = moment().format("YYYY-MM-DD");
        }
      }

      this.fetchPointLogs();
    },
    dateEndChange(value) {
      this.endAt = moment(value).format("YYYY-MM-DD");

      if (moment(value).diff(moment(this.startAt)) < 0) {
        this.startAt = moment(value).format("YYYY-MM-DD");
      }

      if(this.filterByDate.show_option) {
        this.startAt = moment(this.endAt).subtract(this.daysDiff, "days").format("YYYY-MM-DD");
      }

      this.fetchPointLogs();
    },
    dateOptionChange(e) {
      let value = e.target.value;

      let filter = this.filterByDate;

      if (filter.show_calendar) {
        /* if (moment().diff(moment(this.startAt).add(value, "days")) < 0) {
          this.startAt = moment().subtract(value, "days").format("YYYY-MM-DD");
          this.endAt = moment().format("YYYY-MM-DD");
        } else {
          this.endAt = moment(this.startAt)
            .add(value, "days")
            .format("YYYY-MM-DD");
        } */

        this.startAt = moment(this.endAt).subtract(value, "days").format("YYYY-MM-DD");

      } else {
        this.startAt = moment().subtract(value, "days").format("YYYY-MM-DD");
        this.endAt = moment().format("YYYY-MM-DD");
      }

      this.daysDiff = value;

      this.fetchPointLogs();
    },
    fixDate(e) {
      return moment(e).format("YYYY-MM-DD");
    },
    formatPointAdjust(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }
      const str = String(value).trim();
      const signMatch = str.match(/^([+-])/);
      const sign = signMatch ? signMatch[1] : "";
      const num = parseInt(sign ? str.slice(1) : str, 10);
      if (Number.isNaN(num)) {
        return str;
      }
      return `${sign}${num.toLocaleString("en-US")}`;
    },

  },
};
</script>

<style lang="scss" scoped>
.records-list {
  padding: 12px;
  padding-bottom: 0;
  background: #fff;
}


.field {
  &__input {
    font-weight: 500;
    font-size: 16px;
    color: var(--liff-primary_text_color);
    border: none;
    border-bottom: 1px solid #e5e5ea;
    background: transparent;
    padding-bottom: 8px;
    width: 100%;
    border: 1px solid #e5e5ea;
    border-radius: 5px;
    padding: 8px 12px;
    &::placeholder {
      color: #b7b7b7;
    }
    &:focus {
      border: 1px solid var(--liff-primary_text_color);
    }
    &.invalid {
      border-bottom: 1px solid #fe0000;
    }
    &:read-only {
      background-color: #f0f0f0;
    }
  }
}

select {
  border: 1px solid #e5e5ea;
  border-radius: 0.5rem;
  padding: 0 1rem;
}
</style>
